import axios from 'axios';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';
import IMask from 'imask';

const helpers = window.BASE_HELPERS || {};
const { Copy, MessageBox, Forms } = helpers;

const MODULE = document.querySelectorAll('[data-module="formulario_contato"]');
const RECAPTCHA_ACTION = 'fale_conosco';

class FormularioContato {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    enableSubmitAfterRecaptchaValid(buttonSubmit) {
        Forms.reloadCaptcha(RECAPTCHA_ACTION, 'recaptcha_token', (token) => {
            if (!token) return;

            buttonSubmit.removeAttribute('disabled');
        });
    }

    init() {
        this.components.forEach(component => {
            new Bouncer('#contato', {
                disableSubmit: true,
                messageAfterField: false,
                messages: {
                    missingValue: {
                        checkbox: '',
                        radio: '',
                        select: '',
                        'select-multiple': '',
                        default: 'Campo de preenchimento obrigatório',
                    },
                    patternMismatch: {
                        email: 'Por favor, insira um e-mail válido',
                        telefone: 'Por favor, insira um telefone válido',
                        default: 'Formato inválido',
                    },
                },
                emitEvents: true,
            });

            const form = component.querySelector('form');
            const buttonSubmit = form.querySelector('[type="submit"]');
            const fields = form.querySelectorAll('input, textarea, select');

            const onFirstFocus = () => {
                this.enableSubmitAfterRecaptchaValid(buttonSubmit);
            };

            fields.forEach(field => {
                field.addEventListener('focus', onFirstFocus, { once: true });
            });

            IMask(
                form.querySelector('[name="telefone"]'),
                {
                    mask: '(00) 00000-0000'
                }
            )

            form.addEventListener('bouncerFormInvalid', () => {
                if (navigator.vibrate) {
                    navigator.vibrate([100, 50, 100]);
                }
            });

            form.addEventListener('bouncerFormValid', async (event) => {
                event.preventDefault();

                const submitButton = event.target.querySelector('[type="submit"]');

                submitButton.setAttribute('disabled', 'disabled');
                submitButton.innerText = 'Enviando...';

                setTimeout(() => {
                    submitButton.removeAttribute('disabled');
                    submitButton.innerText = 'Enviar mensagem';
                }, 3000);

                MessageBox.showOnce({
                    target: form,
                    position: 'bottom',
                    type: 'success',
                    message: 'Mensagem enviada com sucesso!',
                    classes: 'text-sm text-secundaria-sucesso font-normal pt-[10px]',
                    timeout: 8000,
                });
            });
        });
    }
}

(() => {
    if (MODULE) {
        new FormularioContato();
    }
})();

export default FormularioContato;
